import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, hotVideos } from '@/mocks/home';

const extendedVideos = [
  ...hotVideos,
  {
    id: 9, title: '《大秦帝国》完整系列：从裂变到统一', category: 'tv', cover: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%20with%20ancient%20palace%20and%20golden%20imperial%20robes%2C%20dramatic%20warm%20amber%20lighting%2C%20clean%20cinematic%20background%2C%20historical%20drama%20style&width=640&height=360&seq=video-cover-09&orientation=landscape', views: '3.5亿', rating: 9.6, duration: '60集全', isNew: false, isHot: true,
  },
  {
    id: 10, title: '《鬼灭之刃》无限城篇剧场版', category: 'anime', cover: 'https://readdy.ai/api/search-image?query=Anime%20action%20scene%20with%20dynamic%20sword%20fight%20and%20dramatic%20fire%20effects%2C%20warm%20golden%20and%20crimson%20lighting%2C%20clean%20dark%20background%2C%20Japanese%20anime%20style&width=640&height=360&seq=video-cover-10&orientation=landscape', views: '4.2亿', rating: 9.4, duration: '02:05:00', isNew: true, isHot: true,
  },
  {
    id: 11, title: '《NBA总决赛》2026精华集锦', category: 'sports', cover: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20finals%20game%20action%20with%20dramatic%20arena%20lighting%2C%20golden%20court%20reflections%2C%20clean%20dark%20crowd%20background%2C%20sports%20broadcast%20style&width=640&height=360&seq=video-cover-11&orientation=landscape', views: '1.8亿', rating: 9.2, duration: '00:55:00', isNew: false, isHot: false,
  },
  {
    id: 12, title: '《中国诗词大会》第九季全记录', category: 'variety', cover: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20cultural%20TV%20show%20stage%20with%20traditional%20ink%20painting%20style%20decor%2C%20warm%20golden%20spotlights%2C%20clean%20dark%20stage%20background%2C%20cultural%20program%20style&width=640&height=360&seq=video-cover-12&orientation=landscape', views: '2.1亿', rating: 9.3, duration: '40集全', isNew: true, isHot: false,
  },
];

export default function CategoryPage() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'all';
  const [filteredVideos, setFilteredVideos] = useState(extendedVideos);

  useEffect(() => {
    if (activeTab === 'all') {
      setFilteredVideos(extendedVideos);
    } else {
      setFilteredVideos(extendedVideos.filter((v) => v.category === activeTab));
    }
  }, [activeTab]);

  const currentCategory = categories.find((c) => c.id === activeTab);

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4">
              <a href="/" className="hover:text-primary-600 transition-colors">首页</a>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-900 font-medium">视频分类</span>
              {activeTab !== 'all' && currentCategory && (
                <>
                  <i className="ri-arrow-right-s-line"></i>
                  <span className="text-foreground-900 font-medium">{currentCategory.name}</span>
                </>
              )}
            </nav>

            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              视频分类
            </h1>
            <p className="text-sm text-foreground-500">
              按分类浏览海量视频资源，找到您感兴趣的内容
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
          <div className="bg-background-100 rounded-2xl p-1.5 mb-8 overflow-x-auto">
            <div className="flex items-center gap-1.5 min-w-max">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.id === 'all' ? '/category' : `/category?tab=${cat.id}`}
                  className={`flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    activeTab === cat.id
                      ? 'bg-background-50 text-foreground-900'
                      : 'text-foreground-500 hover:text-foreground-900 hover:bg-background-50/60'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
            {filteredVideos.map((video) => (
              <a
                key={video.id}
                href={`/article/${video.id}`}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:scale-[1.02] transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={video.cover}
                    alt={video.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs font-medium">
                    {video.duration}
                  </div>
                  {video.isNew && (
                    <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">新</div>
                  )}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                      <i className="ri-play-fill text-2xl"></i>
                    </div>
                  </div>
                </div>
                <div className="p-3.5">
                  <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2">
                    {video.title}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                      {video.rating}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {video.views}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {filteredVideos.length === 0 && (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-background-100 text-foreground-400">
                <i className="ri-video-line text-2xl"></i>
              </div>
              <p className="text-foreground-500">该分类暂无视频，请浏览其他分类</p>
            </div>
          )}
        </div>

        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: '视频分类 - 91在线观看',
          description: '按分类浏览海量视频资源，找到您感兴趣的内容',
          isPartOf: { '@type': 'WebSite', name: '91在线观看', url: 'https://www.91zaixianguankan.com/' },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.91zaixianguankan.com/' },
              { '@type': 'ListItem', position: 2, name: '视频分类', item: 'https://www.91zaixianguankan.com/category' },
            ],
          },
        }) }} />
      </main>
      <Footer />
    </>
  );
}